<template lang="pug">
.container-fluid
  //- h1 Orders
  .card.shadow.mb-4
    .cart-top.card-header.py-3   
      .col-12
        .row   
          .col-lg-4.col-12
            h2.font-weight-bold.text-primary.text-left() Orders
          .col-lg-8.col-12.text-right
            button.order-btn.btn.btn-primary.text-right(v-on:click="importOrders()")
              i.fas.fa-fw.fa-file-import
              | Import
            button.order-btn.btn.btn-primary.text-right(v-on:click="openOrder()")  
              i.fas.fa-fw.fa-plus-square
              |Order            
            button.order-btn.btn.btn-primary.text-right(v-on:click="deleteOrder()") Delete Orders
    .searchResults
    .card-body
      .col-12.table-wrap 
        div(style="text-align:center" v-if="loading")
          Spinner(size="medium" message="Loading...")
        transition( name="fade")
          table#tablePreview.table(v-if="!loading")
            thead
              tr
                th(style="width:10px")
                th.text-center(style="width:50px") RMA
                th() Actions
                th Order
                th Recipient
                th Date
                th Total
                th Quantity
                th Age
                th Store
                th Platform
                th State
                //- th Shipping Method
            tbody(v-for="(order, index) in orders")
              tr
                td()
                  input(v-if="order.rma.length == 0" type="checkbox" v-model="order.selected")
                  input(v-if="order.rma.length >0" type="checkbox" disabled v-model="order.selected")
                td.text-center.rmaAccordian(@click="rmaAccordian($event,index)")
                  i.fas.fa-fw.fa-plus.pointer(style="margin:0 auto;" v-if="order.rma.length > 0" title="View RMAs")
                  i.fas.fa-fw.fa-minus.pointer( style="margin:0 auto;" v-if="order.rma.length > 0")
                  //- input(v-if="order.rma.length == 0" type="checkbox" v-model="order.selected")                
                th.orderAction(scope='row').text-center
                  i.fas.fa-fw.fa-edit.pointer(v-on:click="editOrders(index)" title="Edit Order")
                  //- i.fas.fa-fw.fa-print.pointer(@click="" title="Print Return Label")
                  i.fas.fa-fw.fa-truck-loading.pointer(@click="createRMA(index)" title="Create RMA ")
                td(v-if="order.orderName") {{order.orderName}}
                td(v-else) {{order.orderId}}
                td {{order.recipient}}
                td {{order.date | moment("MM/DD/YYYY")}}
                td {{order.total}}
                td {{order.quantity}} 
                td {{ today.getTime() - order.date | duration("humanize") }} ago
                td(v-bind:title="order.storeURL") {{order.nickname}} 
                td {{order.type.toUpperCase()}}
                td(v-if="order.countryCode == 'US'") {{order.stateProvinceCode}}
                td(v-else-if="order.countryCode == 'CA'") {{order.stateProvinceCode}}
                td(v-else-if="order.countryCode == 'IN'") {{order.stateProvinceCode}}
                td(v-else) N/A
                //- td {{order.shipping}}
              tr(style="border:none;")
                td.rma-section(colspan="100%")
                  div.rma(v-bind:ref="`rma`" style="width:100%")
                    table(style="width:100%")
                      thead
                        tr
                          th Actions
                          th.text-center Create Return Label
                          th RMA No.
                          th RMA Status
                          th.text-center RMA Details / Refunds
                      tbody
                        tr(v-for="(rma, idx) in order.rma")
                          //- td {{index}} {{idx}} rmaUpdate(orderIndex, rmaIndex, id, status, oldStatus){
                          td
                            select(v-if="!rma.returnId" @change="rmaUpdate(index, idx, rma._id, rma.status, rma.oldStatus)" v-model="rma.status")
                              option(value="pending") Pending
                              option(value="approved") Approved
                              option(value="rejected") Rejected
                            p(v-else-if="rma.returnId") {{rma.status.replace(/^./,rma.status[0].toUpperCase())}}
                            select(v-else-if="rma.returnId && !rma.returnStatus == 'rejected'" v-model="rma.status") 
                              option(value="pending") Pending
                              option(value="approved") Approved
                              option(value="rejected") Rejected
                          td.text-center()                            
                            i.createReturn.fas.fa-fw.fa-print(v-if="!rma.returnId" @click="createReturnLabel(rma.status, index, rma._id)" v-bind:class="{active: rma.status == 'approved', pointer: rma.status == 'approved'}")
                            i.createReturn.fas.fa-fw.fa-print(v-else-if="rma.returnId && !rma.returnStatus == 'rejected'" )
                            i.createReturn.fas.fa-fw.fa-print(v-else )
                          td # {{rma._id.toUpperCase().match(/.{1,6}/g).join('-')}}
                          td {{rma.status.replace(/^./,rma.status[0].toUpperCase())}}
                          td.text-center 
                            i.fas.fa-fw.fa-info-circle.pointer(@click="rmaShowDetails(index,idx)")
                
      .col-12.text-center(style="display:flex;justify-content:center")
        ul.pagination
          li.page-item.nav-item(title="First Page")
            a.page-link( aria-label='Previous' v-on:click="firstPage()")
              span(aria-hidden='true') «
              span.sr-only Previous
          li.page-item.nav-item
            a.page-link( v-if="page >1" v-on:click="prevPage()") {{page - 1}}
          li.page-item.nav-item
            a.page-link(style="font-weight:bold") {{page}}
          li.page-item.nav-item
            a.page-link( v-if="page < maxPage" v-on:click="nextPage()") {{page + 1}}
          li.page-item.nav-item(v-bind:title="`Last Page: ${maxPage}`")
            a.page-link(aria-label='Next')
              span(aria-hidden='true' v-on:click="lastPage()") »
              span.sr-only Next
      transition( name="fade")
        .orderFormWrap(v-if="orderForm")
          .orderContainer
            .ordergogo(ref="returnOrderForm")
              Order(
                :orderInfo="orderInfo"
                :editOrder="editOrder"
                @orderSaved="orderSaved"
                @closeOrder="closeOrder"
                @orderScrollTop="orderScrollTop"
                @init="init"
              )
          .orderFormBg(v-on:click="closeOrder")
      transition(name="fade")
        .orderFormWrap(v-if="orderImportForm")
          .orderContainer
            .ordergogo()
              OrderImport(
                @closeOrder="closeOrder"
                @init="init"
              )
          .orderFormBg(v-on:click="closeOrder")
      transition(name="fade")
        .orderFormWrap(v-if="rmaForm")
          .orderContainer
            .ordergogo()
              CreateRMA(
                :orderInfo="orderInfo"
                @closeOrder="closeOrder"
                @init="init"
              )
          .orderFormBg(v-on:click="closeOrder")
      transition(name="fade")
        .orderFormWrap(v-if="rmaDetails")
          .orderContainer
            .ordergogo()
              RMADetails(
                :orderInfo="orderInfo"
                @closeOrder="closeOrder"
                @init="init"
              )
          .orderFormBg(v-on:click="closeOrder")
      transition(name="fade")
        .orderFormWrap(v-if="returnLabelForm")
          .orderContainer
            .ordergogo()
              CreateReturnLabel(
                :orderInfo="orderInfo"
                @closeOrder="closeOrder"
                @init="init"
              )
          .orderFormBg(v-on:click="closeOrder")
    
</template>

<script>
import Order from '@/components/Order'
import OrderImport from '@/components/OrderImport'
import CreateRMA from '@/components/CreateRMA'
import CreateReturnLabel from '@/components/CreateReturnLabel'
import RMADetails from '@/components/RMADetails'
import Spinner from 'vue-simple-spinner'
import { mapState } from "vuex";

const APPROVED = 'approved';
const PENDING = 'pending';
const REJECTED = 'rejected';

export default {
  name: 'Orders',
  components:{
    Order,
    OrderImport,
    CreateRMA,
    CreateReturnLabel,
    RMADetails,
    Spinner
  },
  computed:{
    ...mapState(['allChannels','shopifyChannels','apiChannels', 'amazonChannels']),
  },
  props: { },
  metaInfo: {
    title: 'Orders',
  },
  data:function(){
    return{
      today: new Date(),
      query:null,
      orderImportForm:false,
      orders:[],
      page:1,
      limit:25,
      offset:0,
      loading:true,
      orderForm:false,
      rmaForm:false,
      rmaDetails:false,
      returnLabelForm:false,
      maxPage:1,
      orderInfo:null,
      editOrder:false,
      successMsg:null,
      search:{
        orderName:null,
      },      
    }
  },  
  methods:{
    async init(){
      this.loading = true;
        this.axios.get(`/rp/server/order/count`)
        .then(response=>{
          this.maxPage = Math.ceil(response.data.count / this.limit)
        })
        var skipNo = this.page - 1
        this.offset = this.limit * skipNo
        this.axios.get(`/rp/server/order/?limit=${this.limit}&offset=${this.offset}`)
        .then(response=>{
          this.orders = response.data;
          this.orders.forEach((order) => {   
            const result = this.allChannels.find( ({ _id }) => _id === order.channel ) || {};
            order.nickname = result.nickname || '';
            order.storeURL = result.store || '';
            order.type = result.type || '';
            order.quantity = 0;
            order.date = this.$moment(order.date, "MM/DD/YYYY");
            order.orderLineItems.forEach(lineItem => {
              let num = parseInt(lineItem.quantity);
              order.quantity += num;
              lineItem.rmaAvailableQty = num - parseInt(lineItem.rmaQuantity);
            })
            order.rma.forEach(rmaItem =>{
              rmaItem.oldStatus = rmaItem.status;
            })
          })
          
          this.loading = false;
        }).catch(err => {
          this.flash(`An Error occurred while getting orders`, 'error');
        })
      
    },
    rmaAccordian($event,index){ 
      $event.currentTarget.classList.toggle('active');
      this.$refs.rma[index].classList.toggle('active');
    },
    async rmaUpdate(orderIndex, rmaIndex, id, status, oldStatus){
      this.flash(`Updating RMA ${id} to ${status}`, 'info');
      let bodyFormData = new FormData();
      bodyFormData.append('rmaId', id);
      bodyFormData.append('status', status);
      bodyFormData.append('currentStatus', oldStatus);
      const update = await this.axios.post(`/rp/server/rma/update`,bodyFormData);
      if(update.data.rma) {
        this.orders[orderIndex].rma[rmaIndex].oldStatus = status;

        update.data.rma.items.forEach((item) => {
          const { id: orderItemId, quantity } = item;
          let oItem = this.orders[orderIndex].orderLineItems.find(({ id }) => id === orderItemId);
          if ((oldStatus === PENDING || oldStatus === APPROVED) && status === REJECTED) {
            // NOTE: FROM pending / approved TO rejected (add back)
            oItem.rmaQuantity -= quantity;
            oItem.rmaAvailableQty += quantity;
          } else if (oldStatus === REJECTED && (status === PENDING || status === APPROVED)) { 
            // NOTE: FROM rejected TO pending / approved (minus back)
            oItem.rmaQuantity += quantity;
            oItem.rmaAvailableQty -= quantity;
          }
        });

        this.flash(`RMA ${id} - ${status}`, 'success');
      }else {
        this.orders[orderIndex].rma[rmaIndex].status = oldStatus;
        this.flash(`An error occured`, 'error');
      }
    },
    nextPage(){
      this.page ++
      this.init();
    },
    prevPage(){
      this.page --
      this.init();
    },
    firstPage(){
      this.page = 1
      this.init();
    },
    lastPage(){
      this.page = this.maxPage;
      this.init()
    },    
    async importOrders(){
      this.orderImportForm = true
    },
    orderScrollTop(){

    },
    createRMA(order){
      this.orderInfo = this.orders[order];
      this.rmaForm = true;
    },
    rmaShowDetails(orderIndex,rmaIndex){
      this.orders[orderIndex].rma[rmaIndex].items.forEach(thing=>{  
      const result = this.orders[orderIndex].orderLineItems.find( ({ id }) => id === thing.id );
        thing.totalQuantity = result.quantity;
        thing.title = result.title;
        thing.vendor = result.vendor
        thing.sku = result.sku;          
        thing.price = result.price;
      })
      this.orderInfo = this.orders[orderIndex].rma[rmaIndex];
      this.orderInfo.type = this.orders[orderIndex].type
      this.orderInfo.orderId = this.orders[orderIndex].orderId
      this.orderInfo.storeUrl = this.orders[orderIndex].storeURL
      this.rmaDetails = true;
    },
    createReturnLabel(status,orderIndex, rmaId){
      if(status == 'approved') {
        this.orderInfo = this.orders[orderIndex];
        this.orderInfo.rmaId = rmaId;
        this.returnLabelForm = true;
      }
    },
    editOrders(order){
      this.orderInfo = this.orders[order];
      this.editOrder = true;
      this.orderForm = true;
    },
    orderSaved(){},
    async deleteOrder(){
      
      var delVar = false;
      
      for(let i = 0; i < this.orders.length; i++){
        if (this.orders[i].selected == true){
          delVar = true;
        }
      }
      if(delVar){
        var x = confirm('Are you sure you want to delete?')      
        if (x){
          for(let i = 0; i < this.orders.length; i++){
            if (this.orders[i].selected == true){
              var data = new FormData();
              this.flash(`Deleting...`,'success')
              data.append(`orderId`, `${this.orders[i]._id}`)     
              let del = await this.axios.post(`/rp/server/order/delete`,data)
              if (del.data.error) this.flash(del.data.error.message,'error')
              else this.flash(`Deleted Order: ${this.orders[i].orderId}`,'success')
            }
          }
          this.init()
        }
      }else{
        this.flash('Please select an order to delete', 'success')
      }
      
    },
    openOrder(){      
      if(this.apiChannels.length > 0) this.orderForm = true;
      else{
        this.$router.push({path:`/dashboard/connectPlatforms`})
        this.flash('Please create an Custom channel first...', 'error', {timeout:20000},()=>{
        setTimeout(()=>{
        },2000)          
        })
      }
    },
    closeOrder(){
      this.orderForm = false;
      this.orderImportForm = false;
      this.orderInfo = null;
      this.returnLabelForm = false;
      this.editOrder = false;
      this.rmaForm = false;
      this.rmaDetails = false;
    },
  },
  mounted(){
    this.init()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.table tbody+tbody{
  border:none;
}
.orderAction{
  display: flex;
  i{
    margin-right:5px;
  }
}
.table-wrap{
  overflow:auto;
}
.rma-section {
  padding: 0px .75rem;
  background-color: #f6f6f6;
}
.cart-top{
  display:flex;
  justify-content: flex-end !important;
  button{
    margin:0 10px;
  }
}
.createReturn{
  opacity:.5;
}
.createReturn.active{
  opacity:1;
  color:#61bd4f;
}

.orderFormWrap{
  position:fixed;
  display:flex;
  justify-content: center;
  align-items: center;
  width:100vw;
  height:100vh;
  top:0;
  left:0;

  .orderContainer{
    max-width:90vw;
    max-height:800px;
    padding:10px 0px;
    background:white;
    border-radius: 10px;      
    box-shadow: 0px 0px 10px 1px rgba(0,0,0,.5);
    z-index: 9;

    .ordergogo{
      max-width:80vw;
      max-height:80vh;
      overflow: auto;
      border-radius: 5px;
    }
  }
  .orderFormBg{
    width:100%;
    height:100%;
    z-index: -1;
    position: absolute;
    top:0;
    background:rgba(0,0,0,.2);
  }
}

.rmaAccordian{
  i.fas.fa-fw.fa-plus{
    display:block;
  }
  i.fas.fa-fw.fa-minus{
    display:none;
  }
}
.rmaAccordian.active{
  i.fas.fa-fw.fa-plus{
    display:none;
  }
  i.fas.fa-fw.fa-minus{
    display:block;
  }
}
.rma{
  max-height:0px;
  transition:all .3s;
  overflow:hidden;
}
.rma.active{
  max-height:2000px;
}
@media all and (max-width: 768px){
  .cart-top{      
    h2{
      margin-bottom:20px;
    }
    button{
      margin:5px 10px;
    }
  }
}
</style>
